import { createClient } from "@connectrpc/connect";
import { ClientesPlataformaService } from "../../../shared/generated/grpc/plataforma_terceros_clientes_pb";
import { ClienteResponse } from "../../../shared/response/terceros/ClienteResponse";
import { AsignarPlanPayload } from "../../../shared/services/api/payload/terceros/AsignarPlanPayload";
import { ServiceSaveBase } from "../../../shared/services/base/ServiceSaveBase";
import { grpcTransportProvider } from "../../../shared/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../shared/services/grpc/mapConnectError";
import { ClienteService, toClienteResponse } from "./ClienteService";

/** Asigna el plan del cliente; el cliente devuelto reemplaza su fila en la tabla (`upsert` de la base). */
export class AsignarPlanService extends ServiceSaveBase<ClienteResponse, AsignarPlanPayload> {
  protected readonly cache = ClienteService.instance;

  /**
   * gRPC-Web (`ClientesPlataformaService.AsignarPlan`). En plan real el servidor exige fecha y
   * hectáreas > 0; en demo las ignora. Si el cliente no tenía cuenta, el servidor la crea y
   * manda el correo de bienvenida.
   */
  protected async sendSave(payload: AsignarPlanPayload): Promise<ClienteResponse> {
    const client = createClient(ClientesPlataformaService, grpcTransportProvider.get());
    try {
      const item = await client.asignarPlan({
        clienteId: payload.clienteId,
        isDemo: payload.isDemo,
        fechaVencimiento: payload.fechaVencimiento ? BigInt(new Date(payload.fechaVencimiento).getTime()) : undefined,
        maximoHectareas: payload.maximoHectareas ?? undefined,
      });
      return toClienteResponse(item);
    } catch (error) {
      throw mapConnectError(error);
    }
  }
}
